function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.3278 27H0V0H20.3278V27ZM0.783848 26.2344H19.5439V0.765595H0.783848V26.2344Z",
  fill: "#1C6BBA"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.8765 9.64659H2.35156V2.29688H9.8765V9.64659ZM3.13541 8.881H9.09266V3.06247H3.13541V8.881Z",
  fill: "#1C6BBA"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.09863 7.88572V4.03223L4.15326 4.03223L4.15326 7.88572L8.09863 7.88572Z",
  fill: "#1C6BBA"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M17.8979 11.2031H2.35156V11.9687H17.8979V11.2031Z",
  fill: "#1C6BBA"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M17.8979 13.6021H2.35156V14.3676H17.8979V13.6021Z",
  fill: "#1C6BBA"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M17.8979 16.0264H2.35156V16.792H17.8979V16.0264Z",
  fill: "#1C6BBA"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M17.8975 2.29688H11.6006V3.06247H17.8975V2.29688Z",
  fill: "#1C6BBA"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M17.8975 4.72119H11.6006V5.48679H17.8975V4.72119Z",
  fill: "#1C6BBA"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M17.8979 18.4253H2.35156V19.1909H17.8979V18.4253Z",
  fill: "#1C6BBA"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M17.898 23.8101H12.5156V24.5757H17.898V23.8101Z",
  fill: "#1C6BBA"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M17.898 21.3601H12.5156V22.9423H17.898V21.3601Z",
  fill: "#1C6BBA"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M30.2042 10.8459H22.209V11.6115H30.2042V10.8459Z",
  fill: "#1C6BBA"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M30.2042 15.4141H22.209V16.1797H30.2042V15.4141Z",
  fill: "#1C6BBA"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M28.3493 17.8895C28.2448 17.8895 28.1403 17.864 28.0619 17.7874C27.9051 17.6343 27.9051 17.4046 28.0619 17.2515L31.8766 13.5256L28.0619 9.79968C27.9051 9.64656 27.9051 9.41688 28.0619 9.26377C28.2187 9.11065 28.4538 9.11065 28.6106 9.26377L33.0002 13.5511L28.6106 17.8384C28.5583 17.864 28.4538 17.8895 28.3493 17.8895Z",
  fill: "#1C6BBA"
});

function SvgInfoShortIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 27,
    viewBox: "0 0 33 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoShortIcon1);
export default __webpack_public_path__ + "static/media/info-short-icon1.50a0c794.svg";
export { ForwardRef as ReactComponent };